export const videoData = [
  {
    timeFrame: "(2019 – Recent Window)",
    videos: [
      {
        id: 1,
        title: "The empty photoframe (1)",
        description: "MP4 audio-visual file.",
        status: "Available, price on request",
      },
      {
        id: 2,
        title: "The empty photoframe (2)",
        description: "MP4 audio-visual file.",
        status: "Available, price on request",
      },
      {
        id: 3,
        title: "The empty photoframe (3)",
        description: "MP4 audio-visual file.",
        status: "Available, price on request",
      },
      {
        id: 4,
        title: "The empty photoframe (4)",
        description: "MP4 audio-visual file.",
        status: "Available, price on request",
      },
    ],
  },
];
